<template>
  <v-autocomplete
    ref="autocomplete"
    v-add-zuko-tag
    :class="isOptionsCapitalize && 'capitalized-text'"
    :menu-props="isOptionsCapitalize ? {contentClass: 'text-capitalize'} : ''"
    :value="value"
    color="navy-dark"
    outlined
    hide-selected
    hide-details="auto"
    :items="items"
    :loading="isLoading"
    :return-object="returnObject"
    :disabled="isDisabled"
    :hide-no-data="isLoading"
    :item-text="itemText"
    :item-value="itemValue"
    :error-messages="errors"
    :placeholder="placeholder"
    :search-input.sync="search"
    @change="handleChange"
    @update:search-input="handleUpdate"
  >
    <template #no-data>
      <v-list-item>
        <v-list-item-title>
          <template v-if="isLoading">Please, wait...</template>
          <template v-else>
            <template v-if="search">
              {{ noOptionMessage }}
            </template>
            <template v-else>Start typing...</template>
          </template>
        </v-list-item-title>
      </v-list-item>
    </template>
  </v-autocomplete>
</template>

<script>
import {
  debounce,
} from 'lodash';

export default {
  name: 'qz-autocomplete',
  inject: ['isLeadgen'],
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    placeholder: {
      type: String,
      default: '',
    },
    returnObject: {
      type: Boolean,
      default: true,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    isInitSearch: {
      type: Boolean,
      default: false,
    },
    itemText: {
      type: String,
      default: 'text',
    },
    itemValue: {
      type: String,
      default: 'value',
    },
    value: {
      type: [String, Number, Object],
      default: '',
    },
    errors: {
      type: Array,
      default: () => [],
    },
    updateSearch: {
      type: Function,
      default: () => {},
    },
    isOptionsCapitalize: {
      type: Boolean,
      default: false,
    },
    noOptionMessage: {
      type: String,
      default: 'No option found, please try another search',
    },
  },
  data () {
    return {
      isLoading: false,
      search: null,
    };
  },
  created () {
    if (this.isInitSearch && !(this.items && this.items.length)) {
      this.handleUpdate();
    }
  },
  watch: {
    // Added to fix issue, when after selecting value from list you
    // try to search for unexisting value and section remained valid.
    // In this watcher we reset value if user clear field manually.
    // https://seopa01.atlassian.net/browse/SU-1962
    search (val, prevVal) {
      if (prevVal && !val) {
        return this.$emit('change', {
          [this.itemValue]: null,
          [this.itemText]: null,
        });
      }
    },
  },
  computed: {
    text () {
      if (this.isOptionsCapitalize) {
        return this.itemText.toUpperCase();
      }

      return this.itemText;
    },
  },
  methods: {
    handleChange: function (val) {
      if (val === null) {
        return this.$emit('change', {
          [this.itemValue]: null,
          [this.itemText]: null,
        });
      }

      // if items is [Object], emit an Object
      this.$emit('change', val);
    },
    handleUpdate: debounce(async function (val) {
      if (this.isLoading) {
        return;
      }

      // Condition prevent unnecessary call method when input blur
      if (
        val &&
        this.value &&
        (
          this.value[this.itemText] === val ||
          this.value === val ||
          this.items?.[0]?.[this.itemText] === val
        )
      ) {
        return;
      }

      this.isLoading = true;
      await this.updateSearch(val);
      this.isLoading = false;
    }, 300),
  },
};
</script>

<style lang="scss" scoped>
.capitalized-text {
  &::v-deep {
    .v-select__slot input {
      text-transform: capitalize;
    }
  }
}
</style>
